export default function SecurityServiceProvider() {
  this.$get = ($auth, $location) => {
    'ngInject';

    function SecurityService() {
      const self = this;
      
      self.check = (page, route) => {
        const pathRootPart = page.split('/')[1];
        let path = '/';
        if (pathRootPart) {
          path += pathRootPart;
        }

        switch (path) {
          case '/':
          case '/home':
          case '/sign-up-user':
          case '/become-a-mechanic':
          case '/sign-up-mechanic':
          case '/login':
            if ($auth.isFullyLoggedIn()) {
              $auth.currentUser(_ => {
                if ($auth.isUser()) {
                  if ($auth.isActivatedUser()) {
                    $location.path('/bicycle-owner/service-bookings');
                  } else {
                    $location.path('/bicycle-owner/complete-registration');
                  }
                } else if ($auth.isBikeOrganisationOwner()) {
                  $location.path('/organisations');
                } else if ($auth.isMechanic()) {
                  const category = $auth.user().mechanicCategory || $auth.user().appliedForCategory;
                  if ($auth.user().verificationLevel && $auth.user().verificationLevel !== 'NONE') {
                    $location.path('/service-provider/service-bookings').search({});
                  } else if (category) {
                    if (category === 'INDIVIDUAL') {
                      $location.path('/service-provider/verification/individual').search({});
                    } else if (category === 'MOBILE') {
                      $location.path('/service-provider/verification/mobile-shop').search({});
                    } else if (category === 'SHOP') {
                      $location.path('/service-provider/verification/bicycle-shop').search({});
                    }
                  } else {
                    $location.path('/service-provider/verification/type').search({});
                  }
                } else {
                  $location.path('/admin/users');
                }
              })
            }
            break;
          case '/admin':
            if (!$auth.isAdmin()) {
              $location.path('/');
            }
            break;
          case '/complete-social-registration':
            if (!$auth.isPartiallyRegistered()) {
              $location.path('/');
            }
            break;

          case '/bicycle-owner': {
            switch (page) {
              case '/bicycle-owner/book-service':
              case '/bicycle-owner/service-bookings':
              case '/bicycle-owner/bicycles':
              case '/bicycle-owner/notifications':
              case '/bicycle-owner/service-providers/favorite':
              case '/bicycle-owner/service-providers/search':
              case '/bicycle-owner/settings/payments':
              case '/bicycle-owner/settings/transactions': {
                if ($auth.isUser()) {
                  if (!$auth.isActivatedUser()) {
                    $location.path('/bicycle-owner/complete-registration');
                  }
                } else if ($auth.isBikeOrganisationOwner()) {
                  $location.path('/organisations');
                }
              }
            }
            break;
          }

          case '/service-provider': {
            switch (page) {
              case '/service-provider/service-bookings':
              case '/service-provider/notifications':
              case '/service-provider/settings/schedule':
              case '/service-provider/settings/work-areas':
              case '/service-provider/settings/bicycle-shops':
              case '/service-provider/settings/pick-up-and-drop-off':
              case '/service-provider/settings/expertise':
              case '/service-provider/settings/parts':
              case '/service-provider/settings/applications':
              case '/service-provider/settings/security':
              case '/service-provider/payout/payments':
              case '/service-provider/payout/transactions': {
                if ($auth.isUser()) {
                  $location.path('/bicycle-owner/service-bookings');
                } else if ($auth.isBikeOrganisationOwner()) {
                  $location.path('/organisations');
                } else if ($auth.isMechanic()) {
                  if (!$auth.user().mechanicCategory && $auth.user().appliedForCategory) {
                    if ($auth.user().appliedForCategory === 'INDIVIDUAL') {
                      $location.path('/service-provider/verification/individual').search({});
                    } else if ($auth.user().appliedForCategory === 'MOBILE') {
                      $location.path('/service-provider/verification/mobile-shop').search({});
                    } else if ($auth.user().appliedForCategory === 'SHOP') {
                      $location.path('/service-provider/verification/bicycle-shop').search({});
                    } else {
                      $location.path('/service-provider/verification/type').search({});
                    }
                  } else if (!$auth.user().mechanicCategory && !$auth.user().appliedForCategory) {
                    $location.path('/service-provider/verification/type').search({});
                  }
                }
              }
            }
            break;
          }

          case '/select-organisation':
          case '/organisations':
          case '/organisation': {
            if (!$auth.isBikeOrganisationOwner()) {
              $location.path('/');
            }
            break;
          }
        }
      }
    }

    return new SecurityService();
  };
}
